angular.module('moebiusProadapt').controller('ctrlQvRaisonNonRempli',
    ['$scope', '$document', '$http', '$location', '$uibModal', 'promiseTracker', 'mbsEtiService', 'mbsParticipantService', 'moment', function ($scope, $document, $http, $location, $uibModal, promiseTracker, mbsEtiService, mbsParticipantService, moment) {

        $scope.participant = mbsParticipantService.getCurrentParticipant();

        $scope.previousValue = $scope.participant.getValue($scope.questionnaireVisite.questionVisiteRaisonNonRempli);

        //valeurs en dur ici
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD
        $scope.reasons = [
            {value:"raison de service"},
            {value:"le patient n’est pas venu à la visite"},
            {value:"patient fatigué"},
            {value:"refus du patient"},
            {value:"patient trop confus"},
            {value:"autre"}
        ];
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD
        // ATTENTION !!! Ces choix sont figés dès que l'étude commence, PAS QUESTION DE CHANGER UN POIL DE CES CHOIX UNE FOIS L'ETUDE EN PROD

        $scope.saveQuestionVisiteRaisonNonRempli = function () {
            var qvIdsToUpdate = [$scope.questionnaireVisite.questionVisiteRaisonNonRempli.id];
            // set date remplissage QR si vide
            if($scope.participant.getValue($scope.questionnaireVisite.questionVisiteDate) === null) {
                $scope.participant.setValue($scope.questionnaireVisite.questionVisiteDate, moment(new Date()));
                qvIdsToUpdate.push($scope.questionnaireVisite.questionVisiteDate.id);
            }
            $scope.participant.saveQuestionsVisites(qvIdsToUpdate).then(function() {
                $scope.$close();
            });
        };


        $scope.cancelQuestionVisiteRaisonNonRempli = function() {
            $scope.participant.setValue( $scope.questionnaireVisite.questionVisiteRaisonNonRempli, $scope.previousValue);
            $scope.$close()
        };

        var EVENT_TYPES = "keydown keypress"

        function eventHandler(event) {
            if (event.which === 13) {
                // -- champs obligatoire
                if ($scope.participant.participantValuesByQuestionVisiteId[$scope.questionnaireVisite.questionVisiteRaisonNonRempli.id][$scope.questionnaireVisite.questionVisiteRaisonNonRempli.overwritePriority]==null) {
                    return;
                }
                else {
                    $scope.saveQuestionVisiteRaisonNonRempli();
                }
            }
        }

        $document.bind(EVENT_TYPES, eventHandler);
        $scope.$on('$destroy', function () {
            $document.unbind(EVENT_TYPES, eventHandler);
        })

    }]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/qvRaisonNonRempli.js